var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"userQueriesGrid",attrs:{"name":"userQueriesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-751354da","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Statistics/UserQueries.vue
// module id = 902
// module chunks = 1